<template>
  <a-form-model class="form" ref="editForm" label-position="top" size="mini">
    <a-form-model-item label="图标列表">
      <drag-zone class="item-list" :list="items">
        <template v-slot="{ item, index }">
          <div class="func-item">
            <div
              class="func-img"
              :class="[item.icon]"
              :style="{ color: item.color }"
            >
              <img :src="item.img" v-if="item.img" />
            </div>
            <div class="func-info">
              <div class="func-title">
                {{ item.title }}
              </div>
              <div class="func-title-en">
                {{ item.titleEn }}
              </div>
              <div class="func-text">功能：{{ item.funcText }}</div>
            </div>
            <div class="func-btn">
              <a-icon
                type="form"
                class="icon-edit-outline"
                @click="editIcon(index)"
              />
              <a-icon
                type="delete"
                class="icon-delete"
                @click="delIcon(index)"
              />
            </div>
          </div>
        </template>
      </drag-zone>
      <div class="add-item" @click="addItem">
        <div class="add-icon"></div>
        <div class="add-txt">添加图标</div>
      </div>
    </a-form-model-item>
    <a-form-model-item label="一行图标数">
      <a-input type="number" v-model="form.num"></a-input>
    </a-form-model-item>
    <template v-if="form.gap">
      <a-form-model-item label="水平间隔">
        <a-input type="number" v-model="form.gap.horizontal"></a-input>
      </a-form-model-item>
      <a-form-model-item label="垂直间隔">
        <a-input type="number" v-model="form.gap.vertical"></a-input>
      </a-form-model-item>
    </template>
    <a-form-model-item label="图标大小">
      <a-radio-group v-model="form.size">
        <a-radio :value="1">小</a-radio>
        <a-radio :value="2">中</a-radio>
        <a-radio :value="3">大</a-radio>
      </a-radio-group>
    </a-form-model-item>
    <a-form-model-item label="内层间距" v-if="form.padding">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.padding.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.padding.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.padding.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.padding.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="外层间距" v-if="form.margin">
      <a-space>
        <a-input
          type="number"
          class="inline-input"
          placeholder="上"
          v-model="form.margin.top"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="下"
          v-model="form.margin.bottom"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="左"
          v-model="form.margin.left"
        ></a-input>
        <a-input
          type="number"
          class="inline-input"
          placeholder="右"
          v-model="form.margin.right"
        ></a-input>
      </a-space>
    </a-form-model-item>
    <a-form-model-item label="背景色">
      <colorPicker
        default-color="transparent"
        v-model="form.backgroundColor"
        class="color-picker shadow"
      ></colorPicker>
    </a-form-model-item>
    <template v-if="form.item">
      <a-form-model-item label="图标内层间距" v-if="form.item.padding">
        <a-space>
          <a-input
            type="number"
            class="inline-input"
            placeholder="上"
            v-model="form.item.padding.top"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="下"
            v-model="form.item.padding.bottom"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="左"
            v-model="form.item.padding.left"
          ></a-input>
          <a-input
            type="number"
            class="inline-input"
            placeholder="右"
            v-model="form.item.padding.right"
          ></a-input>
        </a-space>
      </a-form-model-item>
      <a-form-model-item label="图标圆角">
        <a-input type="number" v-model="form.item.borderRadius"></a-input>
      </a-form-model-item>
      <a-form-model-item label="图标背景色">
        <colorPicker
          default-color="transparent"
          class="color-picker top shadow"
          v-model="form.item.backgroundColor"
        ></colorPicker>
      </a-form-model-item>
    </template>
    <a-modal
      title="图标配置"
      width="300px"
      :mask-closable="false"
      :visible.sync="ds"
      @ok="confirmIcon"
      @cancel="hideDialog"
    >
      <a-form-model ref="iconForm" :model="icon" :rules="iconRules" v-if="icon">
        <a-form-model-item label="图标样式">
          <div class="select-icon">
            <i
              :class="[icon.icon]"
              :style="{ color: icon.color }"
              v-if="icon.icon"
            ></i>
            <img :src="icon.img" v-else-if="icon.img" />
            <a-button class="select-icon-edit" @click.stop="showIconSelect">
              选择图标
            </a-button>
          </div>
        </a-form-model-item>
        <a-form-model-item label="图标名称" prop="title">
          <a-input placeholder="图标名称" v-model="icon.title"></a-input>
        </a-form-model-item>
        <a-form-model-item label="英文名称" prop="title">
          <a-input placeholder="英文名称" v-model="icon.titleEn"></a-input>
        </a-form-model-item>
        <a-form-model-item label="图标功能" prop="type">
          <a-select v-model="icon.type" placeholder="请选择图标功能">
            <a-select-option v-for="item in icons" :key="item.type">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="文字颜色">
          <colorPicker
            v-model="icon.textColor"
            class="color-picker shadow"
          ></colorPicker>
        </a-form-model-item>
        <template v-if="icon.type == 1">
          <a-form-model-item label="列表类型" prop="listType">
            <a-select
              v-model="icon.listType"
              placeholder="请选择列表类型"
              @change="handleListTypeChange"
            >
              <a-select-option v-for="item in listTypes" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="具体列表" prop="listKey">
            <a-select v-model="icon.listKey" placeholder="请选择具体列表">
              <a-select-option v-for="item in listOptions" :key="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>
        <a-form-model-item
          label="选择文章"
          prop="article"
          v-if="icon.type == 2"
        >
          <a-select
            v-model="icon.article"
            allowClear
            placeholder="输入文章标题搜索"
            show-search
            label-in-value
            :filter-option="false"
            :not-found-content="loading ? undefined : null"
            :default-active-first-option="false"
            @search="searchArticle"
            @change="articleChange"
          >
            <a-select-option v-for="item in articleList" :key="item.id">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="链接地址" prop="url" v-if="icon.type == 3">
          <a-input placeholder="请输入链接地址" v-model="icon.url"></a-input>
        </a-form-model-item>
      </a-form-model>
      <icon-select
        class="select-area"
        ref="iconSelect"
        @select="handleSelect"
      ></icon-select>
    </a-modal>
  </a-form-model>
</template>

<script>
import dragZone from "../drag-zone";
import icons from "../../common/js/icons";
import { clone, randomString, debounce } from "../../common/js/tool";
import iconSelect from "../icon-select";
// 列表类型对应的组件type;
const listTypeStr = [
  null,
  "article",
  "guest",
  "live",
  "file",
  "showroom",
  "video",
];

export default {
  name: "icons-edit",
  components: {
    dragZone,
    iconSelect,
  },
  inject: ["build"],
  props: {
    value: Object,
  },
  data() {
    this.lastFetchId = 0;
    this.searchArticle = debounce(this.searchArticle, 500);
    return {
      form: {},
      items: [],
      icon: null,
      index: null,
      icons: clone(icons),
      listTypes: [
        { name: "文章列表", value: 1 },
        // { name: "嘉宾列表", value: 2 },
        { name: "直播列表", value: 3 },
        // { name: "文件列表", value: 4 },
        // { name: "展厅列表", value: 5 },
        // { name: "学习库列表", value: 6 },
      ],
      listOptions: [],
      loading: false,
      articleList: [],
      iconRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        titleEn: [{ required: true, message: "请输入英文标题", trigger: "blur" }],
        type: [
          { required: true, message: "请选择图标功能", trigger: "change" },
        ],
        listType: [
          { required: true, message: "请选择列表类型", trigger: "change" },
        ],
        listKey: [
          { required: true, message: "请选择具体列表", trigger: "change" },
        ],
        article: [{ required: true, message: "请选择文章", trigger: "change" }],
        url: [{ required: true, message: "请输入链接地址", trigger: "blur" }],
      },
    };
  },
  computed: {
    ds: {
      get() {
        return !!this.icon;
      },
      set(val) {
        !val && this.hideDialog();
      },
    },
  },
  watch: {
    form: {
      handler() {
        this.update();
      },
      deep: true,
    },
    items: {
      handler() {
        this.update();
      },
      deep: true,
    },
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    handleListTypeChange(val) {
      let type = listTypeStr[val];
      let list = this.build.list;
      let options = [{ value: "all", text: "全部" }];
      list.forEach((item) => {
        if (item.type == type) {
          options.push({
            text: item.config.title,
            value: item.key,
          });
        }
      });
      this.listOptions = options;
    },
    handleSelect(select) {
      if (select.icon) {
        //传过来的是icon
        this.$set(this.icon, "icon", select.icon);
        this.$set(this.icon, "img", "");
      }
      if (select.url) {
        //传过来的是img
        this.$set(this.icon, "img", select.url);
        this.$set(this.icon, "icon", "");
      }
    },
    showIconSelect() {
      this.$refs.iconSelect.showIcons();
    },
    searchArticle(val) {
      if (val !== "") {
        this.lastFetchId += 1;
        const fetchId = this.lastFetchId;
        this.articleList = [];

        this.loading = true;
        let url = "/activity/activity-article?filter[title][like]=" + val;
        let build = this.build;
        if (build.isActivity && build.conf) {
          url += `&filter[activity_id]=${build.conf.id}`;
        }
        this.$axios(url)
          .then((res) => {
            if (fetchId !== this.lastFetchId) {
              // for fetch callback order
              return;
            }
            this.articleList = res.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.articleList = [];
          });
      } else {
        this.articleList = [];
      }
    },
    articleChange(value) {
      this.icon.article.info = this.articleList.find(
        (item) => item.id == value.key
      );
      this.articleList = [];
      this.loading = false;
      this.searchArticle(value);
    },
    hideDialog() {
      this.icon = null;
      this.index = null;
      //iconSelect也要隐藏
      this.$refs.iconSelect.hide();
    },
    confirmIcon() {
      let icon = this.icon;
      if (!icon.icon && !icon.img) {
        this.$message.warning("请选择图标样式");
        return;
      }
      this.$refs.iconForm.validate((valid) => {
        if (valid) {
          let item = {
            title: icon.title,
            titleEn: icon.titleEn,
            type: icon.type,
            icon: icon.icon,
            img: icon.img,
          };
          let type = icon.type;
          let temp = icons.find((ic) => ic.type == type);
          item.funcText = temp.funcText;
          if (icon.type == 1) {
            item.listType = icon.listType;
            item.listKey = icon.listKey;
          } else if (icon.type == 2) {
            item.article = icon.article.info;
          } else if (icon.type == 3) {
            item.url = icon.url;
          }
          icon.textColor && (item.textColor = icon.textColor);
          icon.color && (item.color = icon.color);
          let items = this.items;
          //编辑
          if (icon.key) {
            item.key = icon.key;
            this.$set(items, this.index, item);
          } else {
            // 新增
            item.key = `icon_${randomString(6)}`;
            items.push(item);
          }
          this.hideDialog();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    setValue() {
      if (this.value) {
        let temp = clone(this.value);
        this.items = temp.list;
        delete temp.list;
        this.form = temp;
      }
    },
    editIcon(index) {
      let item = this.items[index];
      if (item.type == 1) {
        this.handleListTypeChange(item.listType);
      }
      const icon = clone(item);
      if(icon.type == 2) {
          icon.article = {
              info: icon.article,
              key: icon.article.id,
              label: icon.article.title
          }
      }
      this.icon = icon;
      this.index = index;
    },
    delIcon(index) {
      this.items.splice(index, 1);
    },
    addItem() {
      this.icon = {};
    },
    remove(i) {
      this.items.splice(i, 1);
    },
    update() {
      let temp = clone(this.form);
      let list = clone(this.items);
      temp.list = list;
      this.$emit("change", temp);
    },
    validate() {
      let msg = null;
      let items = this.items;
      for (let i = 0, l = items.length; i < l; i++) {
        let item = items[i];
        if (item.type == 1 && !item.listType) {
          msg = `请选择第${i + 1}个图标的列表类型`;
        } else if (item.type == 2 && !item.article) {
          msg = `请选择第${i + 1}个图标的文章`;
        } else if (item.type == 3 && !item.url) {
          msg = `请输入第${i + 1}个图标的外链地址`;
        }
        if (msg) {
          break;
        }
      }
      return msg;
    },
  },
};
</script>

<style scoped lang="less">
.form {
  --tip-font-color: #909399;
  --border-color: #dcdfe6;
  --border: 1px solid var(--border-color);
  --back-grey-color: #f2f2f2;
  --main-color: #004098;
}
.func-item {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  padding: 5px 30px 5px 10px;
  border: var(--border);
  cursor: move;
}
.func-img {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: var(--back-grey-color);
  font-size: 20px;
  line-height: 48px;
  text-align: center;
  color: var(--main-color);
  img {
    width: 24px;
    height: 24px;
    vertical-align: text-top;
  }
}
.func-info {
  flex: 1;
  padding: 0 6px;
  line-height: 1;
}
.func-title-en {
  margin-top: 6px;
}
.func-text {
  margin-top: 6px;
  font-size: 12px;
  color: var(--tip-font-color);
}
.func-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  font-size: 20px;
  line-height: 20px;
  color: var(--tip-font-color);
  .icon-edit-outline,
  .icon-delete {
    cursor: pointer;
  }
}
.select-icon {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: var(--main-color);
  i {
    margin-right: 10px;
  }
  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}
.select-area {
  position: absolute;
  top: 160px;
  left: -51px;
  z-index: 1;
}

.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
